import {MenuItem, TextField, TextFieldProps} from '@mui/material';

import {BLUETOOTH_NODE_TYPES, WIFI_POINT_TYPES} from '../../constants/node';

type Props = TextFieldProps & {
  value?: string | null;
  bluetooth?: boolean;
};

const WifiPointTypeSelect = ({bluetooth, ...props}: Props) => {
  return bluetooth ? (
    <TextField {...props} value={props.value ?? ''} select>
      {BLUETOOTH_NODE_TYPES.map((i) => (
        <MenuItem key={i.key} value={i.key}>
          {i.name}
        </MenuItem>
      ))}
    </TextField>
  ) : (
    <TextField {...props} value={props.value ?? ''} select>
      {WIFI_POINT_TYPES.map((i) => (
        <MenuItem key={i.key} value={i.key}>
          {i.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default WifiPointTypeSelect;
